import * as engine from 'store/src/store-engine'
import * as sessionStorage from 'store/storages/sessionStorage'
import * as memoryStorage from 'store/storages/memoryStorage'

export const sessionStore = engine.createStore([sessionStorage, memoryStorage])
